import { defaultHttpClient } from '../../httpClient';
import type { AffiliateAiContentEligibilityResponse } from './types';

/**
 * - 상품상세 진입 시 AI 콘텐츠 초안 생성 진입점 노출 가능 여부를 조회한다.
 */
export const getAffiliateAiContentEligibility = (goodsSno: number) => {
  return defaultHttpClient
    .request<AffiliateAiContentEligibilityResponse>({
      method: 'GET',
      url: '/api/v2/affiliate/ai-content/eligibility/',
      params: { goods_sno: goodsSno },
    })
    .then(result => result.data);
};
